import CRUDServiceOperations from "./CRUDServiceOperations";

class ModelService extends CRUDServiceOperations {
  getModelsFromParent(parent, callback, failureCallback) {
    const url = parent._links.children.href;
    return this.getEntitiesByUrl(url, callback, failureCallback);
  }

  getEntitiesUrl = () => {
    return this.urlFactory.models();
  };
}

export default ModelService;
